export default __webpack_public_path__ + "ab0fd32f145aa3d56d1b0f811e4fc1f0.svg";